import { act } from "react-dom/cjs/react-dom-test-utils.production.min";
import { isLoggedIn } from "./../../../utils/Authentication";
import constants from "../../../utils/constants";
const initialState = {
    loading: false,
    currentUser: null,
    countryList: [],
    statesListInfo: {
        data: [],
    },
    recoveryPasswordInfo: [],
    verifyOtpInfo: [],
    forgotPasswordChange: [],
    userDetailsInfo: [],
    userRegisteredData: []
};
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "LOGIN_REQUESTED":
            return {
                ...state,
                loading: true,
            };
        case "LOGIN_SUCCESS":
            // localStorage.setItem("token", action.payload.data.token);
            // console.log('action.payload.data',action.payload.data);
            // return
            // if(action.payload.data.token && (action.payload.data.mfa_channel === "" || action.payload.data.mfa_channel == null || !(action.payload.data.mfa_channel))){

            const d = action.payload.data;
            const shouldSetToken =
                d.token && (
                    (d.is_mfa_enabled === false && d.is_remindme_later === false && d.mfa_enabled_status == null) ||
                    (d.is_mfa_enabled === false && d.is_remindme_later === false && d.mfa_enabled_status === "notNow") ||
                    (d.is_mfa_enabled === false && d.is_remindme_later === true && d.mfa_enabled_status)
                );
            if (shouldSetToken) {
                sessionStorage.removeItem("temp_token");
                sessionStorage.setItem("token", d.token);
            } else {
                sessionStorage.setItem("temp_token", d.token);
            }
            let currentUser = {
                userId: action.payload.data.userid,
                email: action.payload.data.email,
                firstName: action.payload.data.firstname,
                lastName: action.payload.data.lastname,
                phone: action.payload.data.phone,
                countryCode: action.payload.data.countrycode,
                roleId: action.payload.data.roleid,
                profilePic: action.payload.data.profilepic,
                isPlanExpired: action.payload.data.isPlanExpired,
                roleAccess: action.payload.data.access,
                accountName: action.payload.data.businessname,
                accountdetails:action.payload?.data.accountdetails,
                // re
                accountId: action.payload.data.accountid,
                membertierId: action.payload.data.membertier_id,
                userInActiveTime: action.payload.userInActiveTime ? Number(action.payload.userInActiveTime) : constants.USER_INACTIVE_TIME,
                dealerInventoryExpiryDate: action.payload.data.dealerinventory_expirydate,
                dealerInventorySubscription: action.payload.data.dealerinventory_plan,
                isDealerInventoryExpired: action.payload.data.IsDealarInventoryExipred,
                planDetails: action.payload.data.plandetails,
                transferPendingCount: Number(
                    action.payload?.data?.transfer_pendingcount ??
                    action.payload?.data?.transferPendingCount ??
                    action.payload?.data?.transfer_pending_count ??
                    0
                ),
                is_business_enable:action.payload.data.is_business_enable,
            };
            window.sessionStorage.setItem('userDetails', JSON.stringify(currentUser));
            return {
                ...state,
                loading: false,
                currentUser: currentUser,
            };
        case "LOGIN_FAILED":
            localStorage.removeItem("token");
            sessionStorage.removeItem("token");
            window.sessionStorage.removeItem('userDetails');
            return {
                ...state,
                loading: false,
                currentUser: null,
            };

             case "UPDATE_PROFILE_PIC":
              const updatedUser = updateSessionUser(state, { profilePic: action.payload });
               return { ...state, currentUser: updatedUser };

        case "LOGOUT":
            sessionStorage.removeItem('token');
            window.sessionStorage.removeItem("userDetails");
            // localStorage.removeItem("UserBusinessDetails");

            return {
                ...state,
                loading: false,
                currentUser: null,
            };
        case "TOKEN_VERIFIED":
            return {
                ...state,
                currentUser: action.payload
            };

        case "SIGNUP_REQUESTED":
            return {
                ...state,
                loading: true,
            };
        case "SIGNUP_SUCCESS":
            sessionStorage.setItem("token", action.payload.data.token);
            return {
                ...state,
                loading: false,
            };
        case "SIGNUP_FAILED":
            return {
                ...state,
                loading: true,
            };
        case 'FETCH_COUNTRYLIST_DATA_SUCCESS':
            return {
                ...state,
                countryList: action.payload
            };
        case 'FETCH_STATESLIST_DATA_SUCCESS':
            return {
                ...state,
                statesListInfo: action.payload
            };
        case 'FETCH_RECOVERPASSWORD_DATA_SUCCESS':
            return {
                ...state,
                recoveryPasswordInfo: action.payload
            };
        case 'FETCH_VERIFYOTP_DATA_SUCCESS':
            return {
                ...state,
                verifyOtpInfo: action.payload
            };
        case 'FETCH_FORGOT_PASSWORD_DATA_SUCCESS':
            return {
                ...state,
                forgotPasswordChange: action.payload
            };

        case 'GET_USER_DETAILS_DATA_SUCCESS':
            return {
                ...state,
                userDetailsInfo: action.payload
            };
        case 'USER_REGISTERED_SUCCESS':
            return {
                ...state,
                userRegisteredData: action.payload
            };

        default:
            return state;
    }
}
    function updateSessionUser(state, updates) {
    const oldUser = JSON.parse(sessionStorage.getItem("userDetails")) || {};
    const newUser = { ...oldUser, ...state.currentUser, ...updates };
    sessionStorage.setItem("userDetails", JSON.stringify(newUser));
    return newUser;
}